import { Controller } from "@hotwired/stimulus"
import anime from "animejs"
import { enter, leave } from "@/el-transition"
import { useTransition } from "stimulus-use"

export default class extends Controller {
    static targets = [
        'tab',
        'button',
    ]

    static classes = [
        'hidden',
        'button',
        'buttonActive',
    ]

    static values = {
        index: {
            type: Number,
            default: 0,
        }
    }

    connect() {

    }

    choice({ params: { index } }) {
        this.indexValue = index
    }

    async indexValueChanged(current, old) {
        this.buttonTargets.forEach((element, index) => {
            if (index === current) {
                element.classList.add(...this.buttonActiveClasses)
                element.classList.remove(...this.buttonClasses)
            } else {
                element.classList.add(...this.buttonClasses)
                element.classList.remove(...this.buttonActiveClasses)
            }
        })

        const oldEl = this.tabTargets?.[old]
        const newEl = this.tabTargets?.[current]

        if (oldEl) {
            await leave(oldEl, 'tabs', this.hiddenClass);
        }

        if (newEl) {
            await enter(newEl, 'tabs', this.hiddenClass);
        }
    }
}
